import styled, { css } from 'styled-components';
import { Box, PopoverBase, spacing, radius, Flex } from '@landr/maestro';
import { zIndex } from '../../constants';
import coachmarkStyles from './themes/Coachmark.default';
import iconStyles from './themes/Icon.default';
import { CoachmarkProps, IconWrapperProps } from './Coachmark.types';

export const coachmarkBaseStyles = css`
    /* @maestro-no-token */
    width: auto;
    min-width: 360px;
    padding: ${spacing('xl')};
    margin: ${spacing('sm')};
`;

export const Coachmark = styled(PopoverBase)<CoachmarkProps>`
    ${coachmarkBaseStyles};
    ${coachmarkStyles.root};
    ${({ variant }): ((props: any) => string) =>
        coachmarkStyles.variant[variant]};

    [data-popper-placement^='top'] > & {
        margin-bottom: 0;
    }

    [data-popper-placement^='right'] > & {
        margin-left: 0;
    }

    [data-popper-placement^='bottom'] > & {
        margin-top: 0;
    }

    [data-popper-placement^='left'] > & {
        margin-right: 0;
    }

    & + [data-popper-arrow] {
        z-index: ${zIndex.popover};
        :before {
            ${({ variant }): ((props: any) => string) =>
                coachmarkStyles.variant[variant]};
        }
    }
`;

Coachmark.displayName = 'Styled.Coachmark';

export const IconWrapper = styled(Box)<IconWrapperProps>`
    border-radius: ${radius('round')};
    /* @maestro-no-token */
    width: 32px;
    height: 32px;
    padding: 2px;
    border: 2px solid;

    ${({ variant }): ((props: any) => string) => iconStyles.variant[variant]};
`;

IconWrapper.displayName = 'Styled.IconWrapper';

export const Anchor = styled(Box)`
    pointer-events: none;
`;

export const AnchorAbsolute = styled(Anchor)`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    max-width: 100% !important;
`;

export const AnchorFixed = styled(Anchor)`
    position: fixed;
    width: 0;
    height: 0;
`;

export const Header = styled(Flex)`
    align-items: flex-start;
`;

export const HeaderItem = styled(Flex)``;
